import { useEffect, useState } from 'react'

// Include coarse pointers so rotating a phone does not unexpectedly enable editing.
export const COMPACT_EDITOR_QUERY = '(max-width: 720px), (pointer: coarse)'

export default function useCompactEditor() {
  const [compact, setCompact] = useState(() =>
    window.matchMedia?.(COMPACT_EDITOR_QUERY).matches ?? false
  )

  useEffect(() => {
    const query = window.matchMedia?.(COMPACT_EDITOR_QUERY)
    if (!query) return undefined
    const update = () => setCompact(query.matches)
    update()
    query.addEventListener('change', update)
    return () => query.removeEventListener('change', update)
  }, [])

  return compact
}
